import React, { useEffect, useState } from "react";
import { message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComment,
  faPaperPlane,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { callCreateComment, callFetchComment } from "../../../../config/api";
import ImgDefault from "../../../../assets/images/ngocrong.png";

import "./ModalComment.scss";

const ModalComment = ({
  postId,
  avatar,
  author,
}: {
  postId: string;
  avatar: string;
  author: string;
}) => {
  const [inputValue, setInputValue] = useState(""); // Sử dụng useState để lưu giá trị của input
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comments, setComments] = useState<any[]>([]);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  let queryComment = `current=1&pageSize=100&relatedPost=${postId}`;
  const handleFetchComment = async () => {
    const res: any = await callFetchComment(queryComment);
    try {
      setComments(res.data?.result);
    } catch (error) {
      message.error("có lỗi xảy ra!");
    }
  };
  useEffect(() => {
    handleFetchComment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId]);

  const handleSubmit = async (event: any) => {
    event.preventDefault(); // Ngăn chặn form submit lại trang
    const dataComment: {
      content: string;
      relatedPost: string;
    } = { content: inputValue, relatedPost: postId };
    const res = await callCreateComment(dataComment);
    if (res.statusCode === 201) {
      handleFetchComment();
      setInputValue("");
    } else if (res.statusCode === 400) {
      message.warning("Nội dung không được để trống!");
    } else {
      message.warning("Bạn chưa đăng nhập tài khoản!");
    }
  };

  const handleInputChange = (event: any) => {
    // event.stopPropagation();
    // event.preventDefault();
    setInputValue(event.target.value); // Cập nhật giá trị của input khi có sự thay đổi
  };

  return (
    <div className="wrapper-modal-comments">
      <div className="action-like" onClick={showModal}>
        <FontAwesomeIcon icon={faComment} size="1x" />
        <span>{comments.length} Comments</span>
      </div>
      <div
        className="container-modal"
        style={isModalOpen ? { display: "block" } : { display: "none" }}>
        <header className="title-modal-comment">
          <h3>Bài viết của {author}</h3>
          <FontAwesomeIcon
            icon={faXmark}
            className="icon-xmark"
            onClick={handleCancel}
          />
        </header>
        <div className="wrapper-container-comment">
          {comments &&
            comments.map((item, index) => {
              return (
                <div className="container-comment" key={index}>
                  <img
                    className="avatar-comment"
                    src={
                      item.createdBy?.avatar
                        ? item.createdBy?.avatar
                        : ImgDefault
                    }
                    alt="logo"
                  />
                  <div className="content-comment">
                    <h3>{item.createdBy?.name}</h3>
                    <p>{item.content}</p>
                  </div>
                </div>
              );
            })}
        </div>
        <form className="container-send-comment" onSubmit={handleSubmit}>
          <img src={avatar ? avatar : ImgDefault} alt="logo " />
          <input
            type="text"
            className="input-text-comment"
            value={inputValue}
            onChange={handleInputChange}
          />
          <button className="send-comment" type="submit">
            <FontAwesomeIcon
              className="icon-send-comment"
              icon={faPaperPlane}
              size="1x"
              color="#1677ff"
            />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ModalComment;
